 export default (function () {
  return {
    user: {
      email: "",
      totpVerfied: false,
      userLevel: "",
      id: ""
    },
    kycRefData: {
      countryCode: "",
      countryKycInfo: {
        verificationTypes: [],
        identificationTypes: [],
        minAge: 18
      },
      countryStates: []
    },
    countries: [],
    coins: [],
    refData: {
      defaultCoin: "",
      countryData: {
        countryInfo: {},
        countryStates: [],
        kyc: {
          verificationTypes: [],
          identificationTypes: [],
          minAge: 18
        },
        paymentMethods: []
      },
      coinDecimal: 8,
      fiatDecimal: 2,
      paymentConfirmationTime: 10,
      paymentConfirmationTime: {
        value: 10
      },
      orderStatusSearch: [],
      disputeReasons: {
        buyerDisputeReason: [],
        selleDisputeReason: []
      },
      userOrderFeedback: {
        negative: [],
        postive: []
      },
      adStatuses: ["PUBLISHED", "UNPUBLISHED", "CLOSED"],
      txType: [],
      txStatus: []
    },
    isLoadingArray: []
  };
});

